import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "qa-verse-complete-graph" }
const _hoisted_2 = { class: "qa-vcg-top-bar flex row justify-e" }
const _hoisted_3 = { class: "flex row qa-vcg-order-container align-c" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "qa-vcg-order-label" }, "order:", -1)
const _hoisted_5 = ["onMouseenter"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "qa-vcg-legend flex row justify-c" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TabRadio = _resolveComponent("TabRadio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_TabRadio, {
          options: [{ value: 'verse' }, { value: 'quote' }],
          "model-value": _ctx.ordering,
          "onUpdate:model-value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ordering) = $event)),
          class: "qa-vcg-order-select"
        }, null, 8, ["model-value"])
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["qa-vcg-graph flex row", { 'no-lines': _ctx.verses.length > 100 || (_ctx.verses.length > 40 && !_ctx.$mqs.lg) }]),
      onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.mouseOut && _ctx.mouseOut(...args)))
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.verses, (verse) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["qa-vcg-verse grow-1", _ctx.getState(verse)]),
          key: verse.index,
          onMouseenter: ($event: any) => (_ctx.mouseIn(verse.index))
        }, null, 42, _hoisted_5))
      }), 128)),
      (_ctx.showBox)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "qa-vcg-overlay",
            style: _normalizeStyle(_ctx.boxDim),
            title: _ctx.title
          }, null, 12, _hoisted_6))
        : _createCommentVNode("", true)
    ], 34),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(['correct', 'incorrect', 'skipped', 'incomplete'].filter(
          (l) => l !== 'incomplete' || _ctx.showIncomplete
        ), (label) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "qa-vcg-legend-label flex row align-c",
          key: label
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["qa-vcg-ll-square", label])
          }, null, 2),
          _createTextVNode(" " + _toDisplayString(label), 1)
        ]))
      }), 128))
    ])
  ]))
}